import lodashUniq from 'lodash/fp/uniq';
import lodashPick from 'lodash/fp/pick';

export const summary = [
  'id',
  'listedDate',
  'createdDate',
  'lastActiveDate',
  'sunroomPhotoUrls',
  'watermarkedPhotoUrls',
  'concessionPhotoUrls',
  'useWatermarks',
  'hiddenPhotoUrls',
  'comboPhotoUrls',
  'price',
  'maxUnitPrice',
  'minUnitPrice',
  'dataSource',
  'apartmentName',
  'apartmentEmail',
  'apartmentPhone',
  'managementCompanyPhone',
  'bedrooms',
  'bathrooms',
  'squareFeet',
  'availableDate',
  'updatedDate',
  'yearBuilt',
  'yearRenovated',
  'listingBroker',
  'mlsNumber',
  'status',
  'mlsStatus',
  'policySpecials',
  'occupantType',
  'propertyType',
  'pinned',
  'lockboxType',
  'apartmentOfficeHours',
  'section8',
  'smartApartmentId',
  'numberOfUnits',
  'coSigners',
  'policyElectricPaid',
  'policyGasPaid',
  'policyTrashPaid',
  'policyWaterPaid',
  'policyPestControlpaid',
  'policyGardeningPaid',
  'sunlockId',
  'marketId',
  'schoolDistrict',
  'schoolElementary',
  'schoolMiddle',
  'schoolSeniorHigh',
  'displayType',
  'apartmentUnit',
  'listingManagementCompany',
  'partnerId',
  'cantTourFlag',
  'hasOnlineApp',
  'mlsDaysOnMarket',
  'apartmentBuildingId',
  'floorPlanId',
  'igloohomeLockId',
  'codeboxLockId',
  'codeboxLocationPhotos',
  'codeboxInstructions',
  'electronicLockCode',
  'electronicLockInstructions',
  'externalApplicationLink',
  'walkToUnitInstructions',
  'walkToUnitPhotoUrls',
  'landlordNotificationAlert',
  'landlordPropertyAccessNotificationAlert',
  'minLeaseMonths',
  'maxLeaseMonths',
  'vacantDate',
  'services',
  'hasAlarmCode',
];

export const apartmentUnits = ['id', 'dataSource', 'apartmentName', 'apartmentUnits'];

export const fees = [
  'administrationFee',
  'applicationFee',
  'bikeRackFee',
  'cableAndInternetCombinedFee',
  'cableFee',
  'carportFee',
  'collectLastMonthRent',
  'coveredParkingFee',
  'electricFee',
  'garageAttachedParkingSpotFee',
  'garageDetachedParkingSpotFee',
  'id',
  'internetFee',
  'monthlyCommunityFee',
  'monthlyPetRent',
  'packageLockerSystemFee',
  'pestControlFee',
  'petDeposit',
  'petDepositMax',
  'petFee',
  'petFeeMax',
  'reservedParkingSpotFee',
  'residentBenefitsPackageFee',
  'securityDeposit',
  'storageFee',
  'surfaceParkingFee',
  'valetTrashFee',
  'wasteWaterFee',
  'waterAndSewerFee',
];

export const booleanAmenitiesFieldgroup = [
  'hasPool',
  'hasGarage',
  'hasMasterOnMain',
  'petsAllowed',
  'petsNegotiable',
  'dogsAllowed',
  'catsAllowed',
  'petWeight',
  'petBreedRestriction',
  'hasTileFlooring',
  'hasWoodFlooring',
  'hasCarpetFlooring',
  'hasConcreteFlooring',
  'hasVinylFlooring',
  'hasStainlessSteelAppliances',
  'hasGasStove',
  'hasElectricStove',
  'hasFence',
  'hasYard',
  'hasWasher',
  'hasDryer',
  'hasWasherDryer',
  'hasWasherDryerConnections',
  'hasCommunalWasherDryer',
  'hasStackedWasherDryer',
  'hasFencedYards',
  'hasDogWalkPark',
  'hasAccessGates',
  'hasFitnessCenter',
  'isHandicapFriendly',
  'hasHotTubSpaJacuzzi',
  'hasJoggingTrail',
  'hasRefrigerator',
  'hasMicrowave',
  'hasDishWasher',
  'hasWaterSoftener',
  'hasCentralHeating',
  'hasWheelchairAccessible',
  'hasBalcony',
  'hasOven',
  'hasDeck',
  'hasPatio',
  'hasShowerTub',
  'hasAirConditioning',
  'hasWalkInClosets',
  'hasExtraStorage',
];

export const amenities = [
  'id',
  'hasPool',
  'hasGarage',
  'hasMasterOnMain',
  'parkingSpaces',
  'petsAllowed',
  'petsNegotiable',
  'dogsAllowed',
  'catsAllowed',
  'maximumPetsAllowed',
  'petWeight',
  'petBreedRestriction',
  'hasTileFlooring',
  'hasWoodFlooring',
  'hasCarpetFlooring',
  'hasConcreteFlooring',
  'hasVinylFlooring',
  'hasStainlessSteelAppliances',
  'hasGasStove',
  'hasElectricStove',
  'hasFence',
  'hasYard',
  'hasWasher',
  'hasDryer',
  'hasWasherDryer',
  'hasWasherDryerConnections',
  'hasCommunalWasherDryer',
  'hasStackedWasherDryer',
  'hasFencedYards',
  'hasDogWalkPark',
  'hasAccessGates',
  'hasFitnessCenter',
  'isHandicapFriendly',
  'hasHotTubSpaJacuzzi',
  'hasJoggingTrail',
  'hasRefrigerator',
  'hasMicrowave',
  'hasDishWasher',
  'garageSpaces',
  'hasWaterSoftener',
  'hasCentralHeating',
  'hasWheelchairAccessible',
  'hasBalcony',
  'hasOven',
  'hasDeck',
  'hasPatio',
  'hasShowerTub',
  'hasAirConditioning',
  'hasWalkInClosets',
  'hasExtraStorage',
];

export const zillowExtraAmenities = [
  'hasGarage',
  'hasMasterOnMain',
  'hasTileFlooring',
  'hasWoodFlooring',
  'hasCarpetFlooring',
  'hasConcreteFlooring',
  'hasVinylFlooring',
  'hasStainlessSteelAppliances',
  'hasGasStove',
  'hasElectricStove',
  'hasWasherDryerConnections',
  'hasDishWasher',
  'hasWheelchairAccessible',
  'hasShowerTub',
  'hasWalkInClosets',
  'hasExtraStorage',
  'hasHotTubSpaJacuzzi',
  'hasDogWalkPark',
  'hasAccessGates',
  'hasJoggingTrail',
  'hasWaterSoftener',
];

export const address = [
  'id',
  'addressStreetName',
  'addressStreetNumber',
  'addressStreetSuffix',
  'addressStreetDisplay',
  'addressZip',
  'addressCity',
  'addressCountryCode',
  'addressStateCode',
  'apartmentUnit',
];

export const comparativeMarketAnalysis = [
  'comparativeMarketAnalysisRentPrice',
  'comparativeMarketAnalysisPdfUrl',
  'comparativeMarketAnalysisNotes',
  'comparativeMarketAnalysisUpdated',
];

export const photos = [
  'id',
  'photoUrls',
  'photoMappings',
  'sunroomPhotoUrls',
  'watermarkedPhotoUrls',
  'watermarkedPhotoMappings',
  'concessionPhotoUrls',
  'concessionPhotoMappings',
  'useWatermarks',
  'hiddenPhotoUrls',
  'photosAutoenhance',
];

export const photographersUploads = [
  'photoUrls',
  'washerDryerPhotoUrls',
  'lockboxPhotoUrls',
  'comboPhotoUrls',
  'yardSignPhotoUrls',
  'sunlockPhotoUrls',
  'gasStovePhotoUrls',
  'electricStovePhotoUrls',
  'dishWasherPhotoUrls',
  'refrigeratorPhotoUrls',
  'microwavePhotoUrls',
  'washerPhotoUrls',
  'dryerPhotoUrls',
  'washerDryerConnectionsPhotoUrls',
];

export const geo = ['id', 'locationLongitude', 'locationLatitude', 'locationPoint'];

export const showingInfo = [
  'id',
  'showingRemarks',
  'showingInstructions',
  'showingAccessInstructions',
  'lockboxType',
  'lockboxLocation',
  'occupantType',
  'occupantPhone',
  'lockboxCode',
  'notesForShowing',
];

export const descriptions = [
  'id',
  'description',
  'laundryDescription',
  'petDescription',
  'applicationDescription',
  'heatingDescription',
  'acDescription',
  'waterDescription',
  'sewerDescription',
  'utilitiesDescription',
  'ownerPays',
  'tenantPays',
];

export const agent = [
  'listingAgent',
  'listingAgentCellPhone',
  'listingAgentDirectWorkPhone',
  'listingAgentEmail',
];

export const prequalification = [
  'id',
  'price',
  'availableDate',
  'petsAllowed',
  'maximumPetsAllowed',
  'petWeight',
];

export const lease = ['minLeaseMonths', 'maxLeaseMonths'];

export const compensations = ['id', 'compensationPackage'];

export const status = ['status'];

export const ownerPaysFor = [
  'policyElectricPaid',
  'policyGasPaid',
  'policyTrashPaid',
  'policyWaterPaid',
  'policyPestControlpaid',
  'highSpeedInternetIncluded',
  'policyGardeningPaid',
];

export const requiredMlsFields = [
  'price',
  'securityDeposit',
  'lockboxType',
  'occupantType',
  'mlsNumber',
  'mlsStatus',
  'bedrooms',
  'bathrooms',
  'availableDate',
  'petsAllowed',
  'dogsAllowed',
  'catsAllowed',
  'petFee',
  'monthlyPetRent',
  'monthlyPetRentPerPet',
  'lockboxLocation',
  'squareFeet',
  'parkingSpaces',
  'hasGarage',
  'hasHoa',
  'addressStreetNumber',
  'addressStreetDisplay',
  'addressZip',
  'addressCity',
  'yearBuilt',
  'photoUrls',
  'apartmentUnit',
  'dataSource',
  'propertyType',
  'section8',
  'occupantType',
  'occupantPhone',
  'availableDate',
  'addressStreetName',
  'applicationFee',
  'administrationFee',
  'description',
  'showingRemarks',
  'coListingAgentMlsNumber',
  'buyersAgentCommission',
];

export const requiredActiveListingFields = [
  'addressStreetName',
  'addressStreetSuffix',
  'addressStreetNumber',
  'addressZip',
  'addressCity',
  'price',
  'securityDeposit',
  'petsAllowed',
  'dogsAllowed',
  'catsAllowed',
  'photoUrls',
  'occupantType',
  'bedrooms',
  'bathrooms',
  'squareFeet',
  'maxLeaseMonths',
  'minLeaseMonths',
  'yearBuilt',
  'availableDate',
  'petWeight',
  'propertyType',
  'locationLongitude',
  'locationLatitude',
  'applicationFee',
  'listingManagementCompany',
  'showingRemarks',
  'lockboxType',
];

export const petFieldsExcludeOnCreate = [
  'petDepositPerPet',
  'petFeePerPet',
  'monthlyPetRentPerPet',
];

export const petFieldsToNullify = [
  'petFee',
  'petDeposit',
  'monthlyPetRent',
  'maximumPetsAllowed',
  'petDescription',
  'petWeight',
  'additionalPetFee',
  'additionalPetDeposit',
  'additionalMonthlyPetRent',
  'petBreedRestriction',
  'petFeeMax',
  'petDepositMax',
  'petDepositPerPet',
  'petFeePerPet',
  'monthlyPetRentPerPet',
];

export const walkthroughFields = [
  'walkthroughPhotoUrls',
  'walkthroughNotes',
  'walkthroughConditions',
  'walkthroughExtraCondition',
  'walkthroughIssuesResolved',
  'walkthroughIssuesResolvedDate',
  'walkthroughPartnerResolvedNotes',
];

export const sunlightListingsSearchFieldgroup = [
  'id',
  'status',
  'addressStreetDisplay',
  'addressCity',
  'addressStateCode',
  'addressZip',
  'listingManagementCompany',
  'mlsNumber',
  'propertyType',
  'partnerId',
];

export const moveInFieldgroup = [
  'leaseTemplateType',
  'customLeaseTemplateUrl',
  'minLeaseMonths',
  'maxLeaseMonths',
  'rentPaymentRecipientName',
  'rentPaymentRecipientAddress',
  'rentPaymentMethods',
  'rentPaymentOtherMethodDescription',
  'isOwnerManaged',
  'propertyManagerType',
  'propertyManagerName',
  'propertyManagerPhone',
  'propertyManagerEmail',
  'invoiceRecipientName',
  'invoiceRecipientEmail',
  'invoiceRecipientPhone',
];

export const occupancyFieldgroup = [
  'occupantType',
  'vacantDate',
  'occupantName',
  'occupantPhone',
  'occupantEmail',
];

export const photoFieldgroup = [
  'requirePhotos',
  'linkToExistingPhotos',
  'availableForPhotoDate',
  'availableForPhotoDateSchedule',
  'availableForPhotoContactName',
  'availableForPhotoContactPhone',
];

export const propertyAccessFieldgroup = [
  'propertySetupAccessType',
  'keyPickupDescription',
  'propertyAccessContactName',
  'propertyAccessContactPhone',
  'propertyAccessContactEmail',
  'gateCode',
  'alarmCode',
  'showingInstructions',
  'lockboxCode',
  'lockboxLocation',
  'accessMethod',
  'propertyAccessCode',
  'supraCbsCode',
  'dateKeyExpectedAtListing',
  'codeboxLocationPhotos',
  'codeboxInstructions',
];

export const pickPropertyAccessFields = lodashPick(propertyAccessFieldgroup);

export const full = lodashUniq([
  ...summary,
  ...apartmentUnits,
  ...fees,
  ...amenities,
  ...address,
  ...geo,
  ...descriptions,
  ...agent,
  ...lease,
  ...compensations,
]);

export const admin = lodashUniq([
  ...full,
  'overrides',
  'listingManagementCompany',
  'lockboxCode',
  'notesForShowing',
  'isSyndicated',
]);

export const tourRouting = lodashUniq([...summary, ...showingInfo, ...address, ...geo]);

export const partnerAmenities = lodashUniq([
  'hasGasStove',
  'hasGasStoveSubmittedDate',
  'gasStovePhotoUrls',
  'gasStovePhotoSubmittedDate',
  'hasElectricStove',
  'hasElectricStoveSubmittedDate',
  'electricStovePhotoUrls',
  'electricStovePhotoSubmittedDate',
  'hasDishWasher',
  'hasDishWasherSubmittedDate',
  'dishWasherPhotoUrls',
  'dishWasherPhotoSubmittedDate',
  'hasRefrigerator',
  'hasRefrigeratorSubmittedDate',
  'refrigeratorPhotoUrls',
  'refrigeratorPhotoSubmittedDate',
  'hasMicrowave',
  'hasMicrowaveSubmittedDate',
  'microwavePhotoUrls',
  'microwavePhotoSubmittedDate',
  'hasWasher',
  'hasDryer',
  'hasWasherSubmittedDate',
  'hasDryerSubmittedDate',
  'washerPhotoUrls',
  'dryerPhotoUrls',
  'washerPhotoSubmittedDate',
  'dryerPhotoSubmittedDate',
  'hasWasherDryerConnections',
  'hasWasherDryerConnectionsSubmittedDate',
  'washerDryerConnectionsPhotoUrls',
  'washerDryerConnectionsPhotoSubmittedDate',
]);

export const partner = lodashUniq([
  ...summary,
  ...address,
  ...photos,
  ...partnerAmenities,
  ...moveInFieldgroup,
  ...requiredMlsFields,
  ...requiredActiveListingFields,
  ...petFieldsToNullify,
  ...occupancyFieldgroup,
  ...propertyAccessFieldgroup,
  ...photoFieldgroup,
  ...comparativeMarketAnalysis,
  'fieldOpsScheduledDate',
  'description',
  'apartmentBuildingId',
  'apartmentUnit',
  'listingManagementCompany',
  'securityDeposit',
  'coListingAgentMlsNumber',
  'postToMls',
  'selfShowingHardwareSerialNumber',
]);

export const partnerEditableAdditionalListingDetails = [
  'hasRefrigerator',
  'hasDishWasher',
  'hasWasher',
  'hasDryer',
  'hasCommunalWasherDryer',
  'hasStackedWasherDryer',
  'hasWasherDryerConnections',
  'hasOven',
  'hasMicrowave',
  'hasFence',
  'hasPool',
  'hasFencedYards',
  'hasYard',
  'hasExtraStorage',
  'hasWalkInClosets',
  'hasShowerTub',
  'hasGarage',
  'hasAirConditioning',
  'hasCentralHeating',
  'hasBalcony',
  'hasDeck',
  'hasPatio',
  'hasWheelchairAccessible',
  'hasWaterSoftener',
  'hasGasStove',
  'hasElectricStove',
];

export const propertyAttributes = [...summary, ...amenities];

export const unit = lodashUniq([
  'id',
  'price',
  'squareFeet',
  'bedrooms',
  'bathrooms',
  'floorPlanId',
  'apartmentBuildingId',
  'apartmentUnit',
  'availableDate',
  'status',
  'sunlockId',
  'igloohomeLockId',
  'codeboxLockId',
  'electronicLockCode',
  'electronicLockInstructions',
  'walkToUnitInstructions',
  'walkToUnitPhotoUrls',
  ...photos,
]);

export const apartmentSelfTourFlowFields = ['walkToUnitInstructions', 'walkToUnitPhotoUrls'];

export const customerIoCollectionFields = [
  'id',
  'price',
  'bedrooms',
  'bathrooms',
  'addressStreetDisplay',
  'sunroomPhotoUrls',
  'watermarkedPhotoUrls',
  'concessionPhotoUrls',
  'useWatermarks',
  'apartmentName',
  'mlsNumber',
  'dataSource',
  'createdDate',
];

export const listingOwnersFieldgroup = [
  'propertyOwnerName',
  'propertyOwnerEmail',
  'propertyOwnerPhone',
  'propertySecondOwnerName',
  'propertySecondOwnerEmail',
  'propertySecondOwnerPhone',
];

export const partnerListingFeeSettingsFieldgroup = [
  'additionalMonthlyPetRent',
  'additionalPetDeposit',
  'additionalPetFee',
  'administrationFee',
  'collectAdminFee',
  'collectFirstMonth',
  'collectFirstMonthTime',
  'collectLastMonthRent',
  'collectPetDeposit',
  'collectPetFee',
  'collectPetRent',
  'collectRbpFee',
  'dataSource',
  'monthlyPetRent',
  'monthlyPetRentPerPet',
  'petDeposit',
  'petDepositPerPet',
  'petFee',
  'petFeePerPet',
  'price',
  'residentBenefitsPackageFee',
  'securityDeposit',
  'securityDepositCollectionInstructions',
  'srStripeAccountId',
  'whoCollectsSecurityDepositPetFees',
];

export const pickPartnerListingFeeSettingsFieldgroup = lodashPick(
  partnerListingFeeSettingsFieldgroup,
);

export const leaseInfoFieldgroup = [
  'isManagementSameAsPropertyOwner',
  'isRepairSameAsManagement',
  'listingAgreementType',
  'listingAgreementUrl',
  'managementEmail',
  'managementName',
  'managementPhone',
  'propertyOwnerEmail',
  'propertyOwnerName',
  'propertyOwnerPhone',
  'propertyOwnerType',
  'rentPaymentDescription',
  'repairContactEmail',
  'repairContactName',
  'repairContactPhone',
  'whoCollectsRentPayment',
];

export const excludeFromDuplicateFieldgroup = [
  'id',
  'mlsNumber',
  'realsavvyListingId',
  'realsavvyListingSourceName',
  'realsavvyListingSourceKey',
  'realsavvyListingDataSourceName',
  'realsavvyListingDataSourceKey',
  'dataSourceListingUpdatedDate',
  'hasBeenSentToRentlinx',
  'externalLinksLocked',
  'createdDate',
  'updatedDate',
  'listedDate',
  'availableDate',
  'availableForSetupDate',
  'lastActiveDate',
  'fieldOpsScheduledDate',
  'status',
  'mlsStatus',
  'postToMls',
  'withdrawalReason',
  'cantTourFlag',
  'listingAgent',
  'agentMlsNumber',
  'listingAgentDataSourceId',
  'listingAgentCellPhone',
  'listingAgentDirectWorkPhone',
  'listingAgentEmail',
  'listingBroker',
  'listingBrokerageMlsNumber',
  'listingBrokerageDataSourceId',
  'coListingAgentMlsNumber',
  'coListingAgentDataSourceId',
  'coListingBrokerageMlsNumber',
  'coListingBrokerageDataSourceId',
  'price',
  'monthlyPetRent',
  'securityDeposit',
  'petDeposit',
  'petsAllowed',
  'dogsAllowed',
  'catsAllowed',
  'maximumPetsAllowed',
  'petDescription',
  'petDepositMax',
  'petFee',
  'petFeeMax',
  'petBreedRestriction',
  'petWeight',
  'petDepositPerPet',
  'monthlyPetRentPerPet',
  'additionalPetFee',
  'petsNegotiable',
  'collectPetDeposit',
  'collectPetFee',
  'collectRbpFee',
  'collectAdminFee',
  'additionalPetDeposit',
  'petFeePerPet',
  'srStripeAccountId',
  'occupantType',
  'occupantPhone',
  'occupantName',
  'occupantEmail',
  'vacantDate',
  'sunlockId',
  'igloohomeLockId',
  'codeboxLockId',
  'lockboxPhotoUrls',
  'yardSignPhotoUrls',
  'lockCodeSetupLocked',
  'lockboxCode',
  'requirePhotos',
  'requireSunlock',
  'sunlockAllowed',
  'yardSignAllowed',
  'partnerMarketingNotes',
  'sunlockInstallationNotes',
  'comboPhotoUrls',
  'sunlockPhotoUrls',
  'photoLiveStatus',
  'photoLiveDate',
  'photoLiveNotes',
  'walkthroughPhotoUrls',
  'walkthroughNotes',
  'walkthroughConditions',
  'walkthroughExtraCondition',
  'walkthroughIssuesResolved',
  'walkthroughIssuesResolvedDate',
  'walkthroughPartnerResolvedNotes',
  'mlsDaysOnMarket',
  'accessMethod',
  'propertyAccessCode',
  'supraCbsCode',
  'dateKeyExpectedAtListing',
  'keyPickupDescription',
  'keyPickupPhoto',
  'lockboxLocation',
  'propertySetupAccessType',
  'propertyAccessContactName',
  'propertyAccessContactPhone',
  'propertyAccessContactEmail',
  'codeboxLockId',
  'codeboxLocationPhotos',
  'codeboxInstructions',
  'availableForPhotoDate',
  'availableForPhotoDateSchedule',
  'availableForPhotoContactName',
  'availableForPhotoContactPhone',
  'comparativeMarketAnalysisRentPrice',
  'comparativeMarketAnalysisPdfUrl',
  'comparativeMarketAnalysisNotes',
  'comparativeMarketAnalysisUpdated',
  'comparativeMarketAnalysisNearbyZillowListingsCount',
  'comparativeMarketAnalysisNearbyZillowListingsScreenshotUrl',
  'comparativeMarketAnalysisNearbyZillowListingsUrl',
  'landlordId',
  'landlordPropertyAccessNotificationAlert',
  'landlordNotificationAlert',
  'accessMethod',
  'propertyAccessCode',
  'supraCbsCode',
  'dateKeyExpectedAtListing',
  'photoLiveStatus',
  'photoLiveDate',
  'photoLiveNotes',
  'crmPropertyId',
  'crmPropertyUniqueId',
  'firstActiveDate',
  'lastActiveDate',
];

export const petPolicyFieldgroup = [
  'catsAllowed',
  'dogsAllowed',
  'maximumPetsAllowed',
  'petWeight',
];

export const petDepositAndFeesFieldgroup = [
  'petDeposit',
  'petDepositPerPet',
  'additionalPetDeposit',
  'petFee',
  'petFeePerPet',
  'additionalPetFee',
  'monthlyPetRent',
  'monthlyPetRentPerPet',
  'additionalMonthlyPetRent',
];

export const partnerEditListingFieldgroup = [
  ...partnerListingFeeSettingsFieldgroup,
  ...petPolicyFieldgroup,
  ...petDepositAndFeesFieldgroup,
];

export const pickPartnerEditListingFields = lodashPick(partnerEditListingFieldgroup);

export default {
  summary,
  apartmentUnits,
  fees,
  amenities,
  address,
  photos,
  geo,
  showingInfo,
  descriptions,
  agent,
  lease,
  compensations,
  status,
  requiredMlsFields,
  petFieldsToNullify,
  walkthroughFields,
  apartmentSelfTourFlowFields,
  comparativeMarketAnalysis,
  petPolicyFieldgroup,
  partnerEditListingFieldgroup,
  pickPartnerEditListingFields,
};
